import React from "react";
import { Link, graphql } from "gatsby";
import Layout from "../components/layout";
import SEO from "../components/seo";
import Img from "gatsby-image";
import EmptyPicture from "../components/svg/emplyPicture";
const BlogIndex = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata?.title || `Title`;
  const posts = data.allWordpressPost.nodes;

  if (posts.length === 0) {
    return (
      <Layout location={location} title={siteTitle}>
        <SEO title="All posts" />
        <p>
          No blog posts found. Add markdown posts to "content/blog" (or the
          directory you specified for the "gatsby-source-filesystem" plugin in
          gatsby-config.js).
        </p>
      </Layout>
    );
  }

  return (
    <Layout location={location} title={siteTitle}>
      <SEO title="All posts" />
      <BlogList posts={posts} />
    </Layout>
  );
};

const BlogList = ({ posts }) => {
  return (
    <section
      className="text-gray-600 body-font overflow-hidden"
      style={{ borderRadius: "5px" }}
    >
      <div className="container px-5 py-24 mx-auto">
        <div className="-my-8 divide-y-2 divide-gray-100">
          {posts.map((post) => {
            return (
              <div key={post.id} className="py-4 flex flex-wrap md:flex-nowrap">
                <div className="md:w-64 md:mb-0 mb-6 flex-shrink-0 flex flex-col px-4 w-full">
                  {post.featured_media ? (
                    <Img
                      fluid={
                        post.featured_media.localFile.childImageSharp.fluid
                      }
                      style={{ borderRadius: "5px" }}
                      alt=""
                      className="object-cover  w-full"
                    />
                  ) : (
                    <EmptyPicture />
                  )}
                </div>
                <div className="md:flex-grow flex flex-col px-4">
                  <div className="flex-grow">
                    <Categories list={post.categories} />
                    <Link to={post.slug} itemProp="url">
                      <h2
                        className="text-2xl font-medium text-cyan-700 hover:text-teal-500 title-font"
                        itemProp="headline"
                        dangerouslySetInnerHTML={{ __html: post.title }}
                      />
                    </Link>

                    <p
                      className="leading-relaxed"
                      dangerouslySetInnerHTML={{
                        __html: post.excerpt,
                      }}
                      itemProp="description"
                    />
                  </div>
                  <div className="  flex items-center flex-wrap ">
                    <Link
                      to={post.slug}
                      itemProp="url"
                      className="text-cyan-700 hover:text-teal-500 inline-flex items-center md:mb-2 lg:mb-0"
                    >
                      Learn More
                      <svg
                        className="w-4 h-4 ml-2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M5 12h14"></path>
                        <path d="M12 5l7 7-7 7"></path>
                      </svg>
                    </Link>
                    <span className="text-gray-400 mr-3 inline-flex items-center  ml-auto leading-none text-sm pr-3 py-1 border-gray-200">
                      {post.date}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

const Categories = ({ list }) => {
  return (
    <>
      {list.map((item, index) => {
        return (
          <h3
            key={`catego_list_${index}`}
            className="inline tracking-widest text-xs title-font font-medium text-gray-400 mr-1"
          >
            {item.name}
          </h3>
        );
      })}
    </>
  );
};
export default BlogIndex;

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allWordpressPost {
      nodes {
        id
        slug
        path
        title
        wordpress_id
        content
        excerpt
        date(formatString: "MMMM DD, YYYY")
        featured_media {
          slug
          localFile {
            childImageSharp {
              fluid(maxWidth: 1600, maxHeight: 1200) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        categories {
          id
          name
          slug
        }
      }
    }
  }
`;
